<template lang="pug">
BriqTable
  thead
    th Date
    th Type
    th Key 
    th Code
    th Message
    th 
  tbody
    template(v-for="item in logData")
      tr.audit-trail-data-col(@click="item.showDetals = !item.showDetals")
        td {{ prettyDate(item.DatetimeUtc) }}
        td(:class="errorTypeClass(item.Type)") {{ item.Type }}
        td {{ item.Key }}
        td {{ item.Code }}
        td {{ item.Message }}
        td
          .show-detals-btn(:class="item.showDetals ? `rotate-180` : ``")
            BriqIcon(name="icon-input-arrow-down-icon")
      tr(v-if="item.showDetals")
        td(colspan="6") 
          .logs-details-table
            BriqTable
              thead
                th Details
              tbody
                tr
                  td {{ item.Details }}           
</template>

<script>
import logTablesMixin from './logTablesMixin.js'

export default {
  name: 'TimeslotProvenance',
  mixins: [logTablesMixin],
  props: {
    logData: {
      type: Array,
      required: true,
    },
  },
  methods: {
    errorTypeClass(errorType) {
      switch (errorType) {
        case 'Warning':
          return 'warning'
        case 'Fatal':
          return 'fatal'
        case 'Transient':
          return 'info'
        default:
          return 'info'
      }
    },
  },
}
</script>

<style scoped lang="stylus">
@import '~@v/components-global/BriqViewAuditTrail/tableStyle.styl'
</style>
